import React from "react";
import { useTranslation } from "react-i18next";

const youtubeVideos = [
  {
    id: "LmtH2Cs-uVs",
    title: "Kapılar Sürmelidir - Anatolian Rock | Kalenda Project",
  },
  {
    id: "QbuM7lqSC-c",
    title: "Neyleyim Gönül (feat. Leyla Aksun) | Kalenda Project",
  },
  {
    id: "oVTSZfqJfC4",
    title: "Tanrıdan Diledim – Anatolian Rock | Kalenda Project",
  },
];

function YoutubeSection() {
  const { t } = useTranslation();

  return (
    <section className="nw-section" id="youtube">
      <div className="nw-section-head">
        <h2>{t("youtube.title")}</h2>
        <p>{t("youtube.subtitle")}</p>
      </div>
      <div className="nw-video-grid">
        {youtubeVideos.map((video) => (
          <div key={video.id} className="nw-video-card">
            <a
              className="nw-video-thumb"
              href={`https://www.youtube.com/watch?v=${video.id}`}
              target="_blank"
              rel="noreferrer"
              aria-label={`${video.title} - YouTube`}
            >
              <img
                src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                alt={video.title}
                loading="lazy"
              />
              <span className="nw-video-play" aria-hidden="true" />
            </a>
            <div className="nw-video-meta">
              <span className="nw-video-title">{video.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default YoutubeSection;
